import { useQuery } from '@tanstack/react-query';
import { fetchEstablishment, fetchEstablishments } from '../queries/establishments.queries';

export const useEstablishments = () =>
    useQuery({
        queryKey: ['establishments'],
        queryFn: () => {
            return fetchEstablishments();
        },
    });

export const useEstablishment = (id: number) => {
    return useQuery({
        queryKey: ['establishment', id],
        queryFn: () => {
            if (Number.isNaN(id)) return null;
            return fetchEstablishment(id);
        },
    });
};
